import { Component, DestroyRef, inject, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';

@Component({
  selector: 'fgb-benefits-worksheet-list',
  templateUrl: './benefits-worksheet-list.component.html',
  styleUrls: ['./benefits-worksheet-list.component.scss'],
})
export class BenefitsWorksheetListComponent implements OnInit {
  @Input() isList: boolean = true;
  @ViewChild('outlet', { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef: TemplateRef<any>;
  isWorksheetItems: boolean = false;
  currentItem: WorksheetItem;
  worksheetId: number;
  worksheetType = WorksheetType;
  currentPage: string = this.router.url.replace('/', '');
  worksheets$ = this.worksheetQuery.getWorksheetByRoute(this.currentPage);
  private _destroyRef = inject(DestroyRef);

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}

  ngOnInit() {
    if (!this.worksheetQuery.hasRoute(this.currentPage)) {
      firstValueFrom(this.worksheetService.fetchWorksheetByRoute(this.currentPage));
    }
    this.worksheets$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data) => {
      if (data.length > 0 && data[0].Items) {
        const activeItems = this.getActiveItems(data);
        if (activeItems.length > 0) {
          this.isWorksheetItems = false;
          this.currentItem = activeItems[0];
        } else {
          this.isWorksheetItems = true;
        }
        data.forEach((item) => {
          if (item.WorksheetId) {
            this.worksheetId = item.WorksheetId;
          }
        });
      }
    });
  }
  private getActiveItems(worksheets: Worksheet[]): WorksheetItem[] {
    return worksheets.flatMap((group: Worksheet) => group.Items.filter((item) => item.WorksheetType === this.worksheetType.ProviderVideo && item.Active === 1));
  }

  selectWorksheetItem(worksheetItem: WorksheetItem) {
    this.currentItem = worksheetItem;
    this.rerender();
  }

  hasWorksheetType(items: WorksheetItem[], value: number): boolean {
    return items.some((item) => item.WorksheetType === value);
  }

  trackByWorksheetId(_index: number, group: Worksheet): number {
    return group.WorksheetId;
  }

  trackByItemId(_index: number, item: WorksheetItem): number {
    return item.Id;
  }

  rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
